import React from 'react';

const Skills = () => {
    return (
        <div id="skill">

        </div>
    );
};

export default Skills;